import { Button } from '@/common/ui/button'
import { useQueryErrorResetBoundary } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { useEffect } from 'react'
import { FallbackProps } from 'react-error-boundary'
import { Navigate, useNavigate, useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'

export interface ErrorPageProps extends FallbackProps {}

export default function ErrorPage({
	error,
	resetErrorBoundary,
}: ErrorPageProps) {
	const navigate = useNavigate()
	const location = useLocation()
	const { reset: resetQueryError } = useQueryErrorResetBoundary()

	useEffect(() => {
		if (error && !(error instanceof AxiosError)) {
			Sentry.captureException(error)
		}
	}, [error])

	useEffect(() => {
		if (error && !(error instanceof AxiosError)) {
			Sentry.captureException(error)
		}
	}, [error])

	if (
		error instanceof AxiosError &&
		error.response?.status &&
		[401].includes(error.response.status)
	) {
		const currentPath = location.pathname + location.search
		const encodedPath = encodeURIComponent(currentPath)
		return <Navigate to={`/login?sessionExpired=true&path=${encodedPath}`} />
	}

	return (
		<div className="absolute left-1/2 top-1/2 mb-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center text-center">
			<span className="bg-gradient-to-b from-foreground to-transparent bg-clip-text text-[10rem] font-extrabold leading-none text-transparent">
				ERROR
			</span>
			<h2 className="font-heading my-2 text-2xl font-bold">
				มีบางอย่างผิดพลาด
			</h2>
			<p>มีข้อผิดพลาดเกิดขึ้น โปรดลองใหม่อีกครั้ง</p>
			<div className="mt-8 flex justify-center gap-2">
				<Button
					onClick={() => {
						if (error instanceof AxiosError) {
							resetQueryError()
						}

						resetErrorBoundary()
					}}
					variant="default"
					size="lg"
				>
					ลองอีกครั้ง
				</Button>
				<Button
					onClick={() => {
						if (error instanceof AxiosError) {
							resetQueryError()
						}

						resetErrorBoundary()
						navigate('/')
					}}
					variant="ghost"
					size="lg"
				>
					กลับไปหน้าแรก
				</Button>
			</div>
		</div>
	)
}
